import mail from './img/email.png'
const Email = () => {
    const email = 'contact@lowcosttv.net';
    const subject = 'Деловое предложение'; 
    const body = 'Приветствую, я представитель из компании ...! Хотел предложить вам свои услуги в ...'; 
    const mailtoUrl = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    return(
        <div>
            <img className='contactIcons' src={mail} alt="mail" /> <a href={mailtoUrl}>contact@lowcosttv.net</a>
        </div>
    )
}

export default Email;